import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const data = [
  { year: '2022', DAVIVIENDA: 0, BAN100: 12 },
  { year: '2023', DAVIVIENDA: 12, BAN100: 5 },
  { year: '2024', DAVIVIENDA: 38, BAN100: 20 },
  { year: '2025', DAVIVIENDA: 30, BAN100: 15 },
  { year: '2026', DAVIVIENDA: 32, BAN100: 50 },
];

const Rendimientos = () => {
  return (
    <div className="text-sm space-y-4">
      <div className="text-[#c1dbff] text-xl font-semibold">Detalles</div>

      <div className="bg-[#edf5fe] p-4 rounded-md w-full text-blue-900">
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data}>
            <XAxis dataKey="year" stroke="#032a61" fontWeight={700} fontSize={16} />
            <YAxis stroke="#032a61" />
            <Tooltip />
            <Legend
              formatter={(value) => <span className="font-bold text-[#032a61]">{value}</span>}
              iconType="circle"
            />
            <Line type="monotone" dataKey="DAVIVIENDA" stroke="#325ef3" strokeWidth={3} dot />
            <Line type="monotone" dataKey="BAN100" stroke="#1c3e93" strokeWidth={3} dot />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-[#edf5fe] p-4 rounded-md flex flex-col justify-start">
        <div className="text-blue-900 font-semibold text-xl mb-3">Proveedores</div>
        <div className="flex items-center text-blue-900 font-semibold">
          <span className="mr-2">BAN100</span>
          <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
          <span>40%</span>
        </div>
        <div className="flex items-center text-blue-900 font-semibold">
          <span className="mr-2">DAVIVIENDA</span>
          <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
          <span>60%</span>
        </div>
      </div>
    </div>
  );
};

export default Rendimientos;
